<template>
  <div>
    <template v-if="this.card">
      <v-card elevation="10">
        <v-card-title class="headline">{{ this.cardHeader }}</v-card-title>
        <AnyChartCore :elevation="0" :chartType="ct" :heightSheet="this.heightSheet" :heightChart="this.heightChart" :dark="this.dark" :dataCollection="datacollection" :options="options" />
      </v-card>
    </template>
    <template v-else>
      <AnyChartCore :elevation="10" :chartType="ct" :heightSheet="this.heightSheet" :heightChart="this.heightChart" :dark="this.dark" :dataCollection="datacollection" :options="options" />
    </template>
    <template v-if="dashboard !== true">
      <UpgradeCore />
    </template>
  </div>
</template>

<script>
import UpgradeCore from "../upgrade/UpgradeCore.vue";

import AnyChartCore from "./AnyChartCore.vue";

import { chartColors } from "../../colors.js";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "AnyChart",
  components: { AnyChartCore, UpgradeCore },
  props: {
    dashboard: {
      type: Boolean,
      default: false,
      required: false,
    },
    heightSheet: {
      type: Number,
      required: true,
    },
    heightChart: {
      type: Number,
      required: true,
    },
    dark: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: false,
    },
    card: {
      type: Boolean,
      default: false,
      required: true,
    },
    cardHeader: {
      type: String,
      default: " ",
      required: false,
    },
    tabs: Number,
    start: String,
    stop: String,
    ct: {
      type: String,
      default: "Line",
      required: true,
    },
  },
  data: () => ({
    chartColors: chartColors,

    /* 
    chartInterval: ["hour", "day", "week", "month", "year", "sixhours"], 
    */

    /*
    MINUTE("M"),
    QUARTER_HOUR("Q"),
    HOUR("H"),
    DAY("d"),
    WEEK("w"),
    MONTH("m");
    */

    fetchSpeed: [5000, 10000, 20000, 20000, 30000, 5000, 1000],

    chartInterval: ["M", "H", "d", "d", "m", "M", "S"],

    limit: ["60", "24", "7", "31", "12", "360", "60"],

    chartLabels: [],
    datacollection: null,
    time: null,

    options: {
      elements: {
        line: {
          tension: 0.3,
          borderWidth: 3,
        },
        point: {
          radius: 0,
        },
      },

      animation: {
        duration: 0,
      },
      hover: {
        mode: "nearest",
        intersect: true,
        animationDuration: 0,
      },
      responsiveAnimationDuration: 0,

      scales: {
        /*         yAxes: [
          {
            scaleLabel: {
              display: true,
            },
            gridLines: {
              drawTicks: true,
              display: true,
            },
          },
        ], */

        yAxes: [
          {
            type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: "left",
            id: "y-axis-1",
            scaleLabel: {
              display: true,
              labelString: "Power / Energy",
            },
          },
          {
            type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: "right",
            id: "y-axis-2",
            scaleLabel: {
              display: true,
              labelString: "State of Charging",
            },
            // grid line settings
            gridLines: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
              /*               drawTicks: true,
              display: true, */
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: true,
            },
          },
        ],
      },

      legend: {
        display: true,
        labels: {
          fontColor: "white",
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    },

    optionsDark: {},
  }),
  created() {
    this.httpGet();
  },
  mounted() {
    this.timer = setInterval(() => {
      this.httpGet();
    }, this.fetchSpeed[this.tabs]);
  },
  methods: {
    toDateTime(input) {
      var t = new Date(input);
      var dateText = "";

      switch (this.tabs) {
        case 0:
          dateText = t.toTimeString().substr(0, 5);
          break;
        case 1:
          dateText = t.toTimeString().substr(0, 5);
          break;
        case 2:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          break;
        case 3:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          break;
        case 4:
          dateText = t.toLocaleString(this.$i18n.locale, {
            year: "numeric",
            month: "long",
          });
          break;
        case 5:
          dateText = t.toTimeString().substr(0, 5);
          break;
        case 6:
          dateText = t.toTimeString().substr(0, 8);
          break;
      }
      return dateText;
    },
    processData(data) {
      var i;
      var soc = [];
      this.chartLabels = [];

      for (i = 0; i < data.labels.length; i++) {
        this.$set(this.chartLabels, i, this.toDateTime(data.labels[i]));
      }

      if (this.$vuetify.theme.dark) {
        this.options.legend.labels = {
          fontColor: "white",
        };
      } else {
        this.options.legend.labels = {
          fontColor: "grey",
        };
      }

      if (!("soc" in data)) {
        for (i = 0; i < data.labels.length; i++) {
          this.$set(soc, i, 0);
        }
      } else {
        for (i = 0; i < data.labels.length; i++) {
          this.$set(soc, i, data.soc[i]);
        }
      }

      if (this.ct == "Line") {
        (this.options.scales.yAxes[0].ticks = {
          callback: function (label) {
            return label.toFixed(1) + " kW";
          },
          /* stepSize: 0.5, */
          beginAtZero: true,
          suggestedMin: -3.6,
          suggestedMax: 3.6,
        }),
          (this.options.scales.yAxes[1].ticks = {
            callback: function (label) {
              return label.toFixed(0) + "  %";
            },
            stepSize: 10,
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 100,
          }),
          (this.datacollection = {
            labels: this.chartLabels,
            datasets: [
              {
                label: this.$i18n.t("charts.legendAY1"),

                backgroundColor: this.chartColors.line.y1.backgroundColor,
                borderColor: this.chartColors.line.y1.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.load),
              },
              {
                label: this.$i18n.t("charts.legendAY2"),

                backgroundColor: this.chartColors.line.y2.backgroundColor,
                borderColor: this.chartColors.line.y2.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.grid),
              },
              {
                label: this.$i18n.t("charts.legendAY3"),

                backgroundColor: this.chartColors.line.y3.backgroundColor,
                borderColor: this.chartColors.line.y3.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.pv),
              },
              {
                label: this.$i18n.t("charts.legendAY4"),

                backgroundColor: this.chartColors.line.y4.backgroundColor,
                borderColor: this.chartColors.line.y4.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.bat),
              },
              {
                label: this.$i18n.t("charts.legendAY5"),

                backgroundColor: this.chartColors.line.y5.backgroundColor,
                borderColor: this.chartColors.line.y5.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-2",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, soc),
              },
            ],
          });
      }

      if (this.ct == "Bar") {
        (this.options.scales.yAxes[0].ticks = {
          callback: function (label) {
            return label.toFixed(1) + " kWh";
          },
          /*           
          stepSize: 0.2,
          beginAtZero: true,
          suggestedMin: -3.6,
          suggestedMax: 3.6, 
          */

          suggestedMin: 0,
        }),
          (this.options.scales.yAxes[1].ticks = {
            callback: function (label) {
              return label.toFixed(0) + "  %";
            },
            stepSize: 10,
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 100,
          }),
          (this.datacollection = {
            labels: this.chartLabels,
            datasets: [
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY1"),

                backgroundColor: this.chartColors.bar.y1.backgroundColor,
                borderColor: this.chartColors.bar.y1.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.load),
              },
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY2"),

                backgroundColor: this.chartColors.bar.y2.backgroundColor,
                borderColor: this.chartColors.bar.y2.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.grid),
              },
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY3"),

                backgroundColor: this.chartColors.bar.y3.backgroundColor,
                borderColor: this.chartColors.bar.y3.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.gridOverflows),
              },
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY4"),

                backgroundColor: this.chartColors.bar.y4.backgroundColor,
                borderColor: this.chartColors.bar.y4.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.pv),
              },
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY5"),

                backgroundColor: this.chartColors.bar.y5.backgroundColor,
                borderColor: this.chartColors.bar.y5.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.bat),
              },
              {
                type: "bar",
                label: this.$i18n.t("charts.legendBY6"),

                backgroundColor: this.chartColors.bar.y6.backgroundColor,
                borderColor: this.chartColors.bar.y6.borderColor,

                fill: true,
                borderWidth: 3,

                yAxisID: "y-axis-1",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, data.batCharged),
              },
              {
                type: "line",
                label: this.$i18n.t("charts.legendBY7"),

                backgroundColor: this.chartColors.bar.y7.backgroundColor,
                borderColor: this.chartColors.bar.y7.borderColor,

                fill: true,
                borderWidth: 3,

                barPercentage: 0.5,
                barThickness: 8,
                maxBarThickness: 8,
                minBarLength: 2,

                yAxisID: "y-axis-2",

                data: this.fillEmptyArrayWithZeroes(data.labels.length, soc),
              },
            ],
          });
      }
    },
    httpGet() {
      let parameters = "?time=" + this.chartInterval[this.tabs] + "&type=" + (this.ct == "Line" ? "P" : "E") + "&limit=" + this.limit[this.tabs];

      if (this.start !== "" && this.stop !== "") {
        parameters += "&dt1=" + this.start + "&dt2=" + this.stop;
      }

      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, parameters, "GET")
        .then((data) => {
          this.processData(data);
        })
        .catch((error) => {
          this.datacollection = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    fillEmptyArrayWithZeroes(x, y) {
      var Arr = y;
      var Diff = x - y.length;

      if (Diff === 0) {
        return Arr;
      }

      Arr.reverse();
      for (let i = 0; i < Diff; i++) {
        Arr.push(0);
      }
      Arr.reverse();

      return Arr;
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
  watch: {
    tabs: function () {
      this.datacollection = null;

      clearInterval(this.timer);

      this.timer = setInterval(() => {
        this.httpGet();
      }, this.fetchSpeed[this.tabs]);

      this.httpGet();
    },
    start: function () {
      this.datacollection = null;
      this.httpGet();
    },
    ct: function () {
      this.datacollection = null;
      this.httpGet();
    },
    dark: function () {
      if (this.dark === true) {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#FFFFFF",
          },
        };
      } else {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#000000",
          },
        };
      }
    },
  },
};
</script>
